<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <div class="col-md-6">
          <div v-for="(customField, index) in customInput" :key="index">
            <div class="form-group bordered mt-3">
              <label :for="customField.key" class="form-label text-left">
                {{ customField.label }}
              </label>
              <input
                v-if="customField.visible"
                type="text"
                class="form-control"
                :name="customField.key"
                :id="customField.key"
                required="required"
                maxlength="255"
                v-model="customField.inputValue"
                @input="() => emitFieldChanged(customField.key)"
              />
            </div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';

export default {
  name: 'FormComplaint',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const customInput = ref(props.data.customInput);
    const showComponentData = ref(false);
    const formData = ref({});

    const cargarDatos = () => {
      try {
        showComponentData.value = customInput.value && customInput.value.length > 0;

        if (customInput.value) {
          customInput.value.forEach((field) => {
            field.label = field.value;
            field.inputValue = '';
            field.visible = true;
          });
          
          formData.value = { ...customInput.value.reduce((acc, field) => {
            acc[field.key] = '';
            return acc;
          }, {}) };
        }
      } catch (error) {
        console.error(error);
      }
    };

    const emitFieldChanged = (key) => {
      const customField = customInput.value.find((field) => field.key === key);
      if (customField) {
        formData.value[key] = customField.inputValue;
        emit('formDataChanged', formData.value);
      }
    };

    watch(() => props.data.customInput, (newCustomInput) => {
      customInput.value = newCustomInput;
      cargarDatos();
    });

    onMounted(cargarDatos);

    return {
      customInput,
      showComponentData,
      emitFieldChanged,
      formData,
    };
  },
};
</script>
